import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Check, Zap, Star } from 'lucide-react';

const plans = [
  {
    id: 'free',
    name: 'Free',
    price: 0,
    period: 'month',
    icon: Zap,
    description: 'Everything you need to get started',
    features: [
      'Unlimited matching',
      'HD video quality',
      'Real-time translation',
      '9+ video filters'
    ]
  },
  {
    id: 'pro',
    name: 'Pro',
    price: 2.99,
    period: 'month',
    icon: Star,
    popular: true,
    description: 'Enhanced features for the best experience',
    features: [
      'All Free features',
      'Priority matching',
      'Gender-based filtering',
      'Country-based filtering'
    ]
  }
];

export function PricingSection() {
  return (
    <section className="py-20 px-4 bg-[#151D2C]">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-4">
          Simple, Transparent Pricing
        </h2>
        <p className="text-gray-400 text-center mb-12">
          Start free, upgrade when you need more
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {plans.map((plan) => (
            <Card
              key={plan.id}
              className={`relative p-8 bg-[#1A2332] border-gray-700 ${
                plan.popular ? 'ring-2 ring-[#11B981] border-[#11B981]' : ''
              }`}
            >
              {plan.popular && (
                <Badge className="absolute -top-3 left-1/2 transform -translate-x-1/2 bg-[#11B981] text-white px-4 py-1">
                  Best Experience
                </Badge>
              )}

              <div className="text-center mb-6">
                <div className="inline-flex items-center justify-center w-12 h-12 bg-[#11B981]/10 rounded-lg mb-4">
                  <plan.icon className="w-6 h-6 text-[#11B981]" />
                </div>
                <h3 className="text-2xl font-bold text-white mb-2">{plan.name}</h3>
                <p className="text-gray-400 text-sm mb-4">{plan.description}</p>
                <div className="mb-4">
                  <span className="text-4xl font-bold text-white">${plan.price}</span>
                  <span className="text-gray-400 ml-1">/{plan.period}</span>
                </div>
              </div>

              <div className="space-y-3">
                {plan.features.map((feature) => (
                  <div key={feature} className="flex items-center">
                    <Check className="w-4 h-4 text-[#11B981] mr-3 flex-shrink-0" />
                    <span className="text-gray-300 text-sm">{feature}</span>
                  </div>
                ))}
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
